import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { database, auth, provider } from './firebase';
import { ref, onValue, push, remove, set, off, get } from "firebase/database";
import { signInWithRedirect, signOut, onAuthStateChanged } from "firebase/auth";

const TURKNET_ADMINS = [
  "musstafacoskun@gmail.com",
  "hayrunisadingil@gmail.com",
  "tturanbaran35@gmail.com",
  "sulenurcazaag@gmail.com",
  "sedaasenguler@gmail.com",
  "naberceorce@gmail.com",
  "recobaba2345@gmail.com"

]; 

const SITETELEKOM_ADMINS = [
  "zuhalydin36@gmail.com",
  "tturanbaran35@gmail.com",
  "hacerak0510@gmail.com",
  "hhaluk36@gmail.com",
  "ozhan247@gmail.com",
  "recobaba2345@gmail.com"

];

function App() {
  const [queue, setQueue] = useState([]);
  const [user, setUser] = useState(null);
  const [maxLimit, setMaxLimit] = useState(3);
  const [isAdmin, setIsAdmin] = useState(false);
  const [activeTab, setActiveTab] = useState('home'); 
  const [logs, setLogs] = useState([]);
  
  const [pendingRequests, setPendingRequests] = useState([]);
  
  const [customName, setCustomName] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(""); 
  const [savedName, setSavedName] = useState(null); 
  const [userCompany, setUserCompany] = useState(null); 
  const [isEditingProfile, setIsEditingProfile] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [darkMode, setDarkMode] = useState(true);
  const [toastMessage, setToastMessage] = useState(null);
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [isAuthChecking, setIsAuthChecking] = useState(true); 

  const prevActiveBreaks = useRef([]);
  const isInitialDataLoaded = useRef(false);
  const isCleaning = useRef(false);

  useEffect(() => {
      const timer = setInterval(() => setCurrentTime(Date.now()), 60000);
      return () => clearInterval(timer);
  }, []);

  const resetTime = new Date(currentTime);
  resetTime.setHours(8, 2, 0, 0); 
  if (new Date(currentTime) < resetTime) {
      resetTime.setDate(resetTime.getDate() - 1); 
  }
  const resetTimestamp = resetTime.getTime();

  const gecerliLoglar = logs.filter(log => log.timestamp >= resetTimestamp);

  const getUserStats = () => {
      const userStats = {};
      const sortedLogs = [...gecerliLoglar].reverse();

      sortedLogs.forEach(log => {
          let isJoin = false;
          let uId = log.uid;
          let uName = log.adSoyad;

          if (log.mesaj.includes("sırada bekleyenler kısmına katıldı.")) {
              isJoin = true;
              if (!uId) { uName = log.mesaj.split(" sırada bekleyenler")[0].replace("⏳ ", ""); uId = uName; }
          } else if (log.mesaj.includes("moladakiler kısmına, mola sırasında boş yer olduğu için katıldı.")) {
              isJoin = true;
              if (!uId) { uName = log.mesaj.split(" moladakiler")[0].replace("☕ ", ""); uId = uName; }
          }

          if (isJoin && uId && uName) {
              if (!userStats[uId]) userStats[uId] = { name: uName, times: [] };
              userStats[uId].name = uName; 
              userStats[uId].times.push(log.timestamp);
          }
      });

      return Object.keys(userStats).map(uid => {
          const stat = userStats[uid];
          const times = stat.times;
          let warnings = [];

          if (times.length > 3) {
              warnings.push(`❗️ Gün içinde 3'ten fazla (${times.length} kez) mola istedi.`);
          }

          for (let i = 1; i < times.length; i++) {
              const diff = times[i] - times[i-1];
              if (diff < 60 * 60 * 1000) { 
                  const date1 = new Date(times[i-1]);
                  const date2 = new Date(times[i]);
                  const t1 = `${date1.getHours().toString().padStart(2,'0')}:${date1.getMinutes().toString().padStart(2,'0')}`;
                  const t2 = `${date2.getHours().toString().padStart(2,'0')}:${date2.getMinutes().toString().padStart(2,'0')}`;
                  warnings.push(`❗️ 1 saat dolmadan tekrar mola istedi (${t1} ve ${t2} arası).`);
              }
          }

          return { name: stat.name, count: times.length, warnings };
      }).sort((a, b) => b.count - a.count); 
  };

  const analyzedUsers = getUserStats();

  useEffect(() => {
    onAuthStateChanged(auth, (u) => {
      setUser(u);
      if (u) {
        const userRef = ref(database, `users/${u.uid}`);
        onValue(userRef, (snapshot) => {
            if (snapshot.exists() && snapshot.val().adSoyad && snapshot.val().company) {
                const dbName = snapshot.val().adSoyad;
                const dbCompany = snapshot.val().company;
                
                setSavedName(dbName);
                setCustomName(dbName); 
                setUserCompany(dbCompany);
                setSelectedCompany(dbCompany);

                if (dbCompany === "turknet" && TURKNET_ADMINS.includes(u.email)) {
                    setIsAdmin(true);
                } else if (dbCompany === "sitetelekom" && SITETELEKOM_ADMINS.includes(u.email)) {
                    setIsAdmin(true);
                } else {
                    setIsAdmin(false);
                    setActiveTab('home');
                }
            } else {
                setSavedName(null);
                setUserCompany(null);
            }
            setIsAuthChecking(false);
        });

        if ("Notification" in window && Notification.permission !== "granted") {
            Notification.requestPermission();
        }
      } else {
        setIsAdmin(false);
        setSavedName(null);
        setUserCompany(null);
        setActiveTab('home');
        setIsAuthChecking(false);
      }
    });
  }, []);

  useEffect(() => {
      if (!isAdmin || !user) return;
      
      const isTurknetAdmin = TURKNET_ADMINS.includes(user.email);
      const isSiteTelekomAdmin = SITETELEKOM_ADMINS.includes(user.email);

      const refs = [];
      const allReqs = { turknet: [], sitetelekom: [] };

      const updateState = () => {
          const combined = [...allReqs.turknet, ...allReqs.sitetelekom];
          combined.sort((a, b) => b.timestamp - a.timestamp);
          setPendingRequests(combined);
      };

      if (isTurknetAdmin) {
          const rRef = ref(database, `transferRequests/turknet`);
          refs.push(rRef);
          onValue(rRef, (snap) => {
              const data = snap.val();
              const arr = [];
              if (data) Object.keys(data).forEach(k => arr.push({id: k, ...data[k]}));
              allReqs.turknet = arr;
              updateState();
          });
      }

      if (isSiteTelekomAdmin) {
          const rRef = ref(database, `transferRequests/sitetelekom`);
          refs.push(rRef);
          onValue(rRef, (snap) => {
              const data = snap.val();
              const arr = [];
              if (data) Object.keys(data).forEach(k => arr.push({id: k, ...data[k]}));
              allReqs.sitetelekom = arr;
              updateState();
          });
      }

      return () => {
          refs.forEach(r => off(r));
      };
  }, [isAdmin, user]);

  useEffect(() => {
    if (!userCompany) return; 

    const queueRef = ref(database, `molaSirasi/${userCompany}`);
    const logsRef = ref(database, `logs/${userCompany}`);
    const settingsRef = ref(database, `settings/${userCompany}/maxLimit`);

    const unsubQueue = onValue(queueRef, (snapshot) => {
      const data = snapshot.val();
      const loaded = [];
      if (data) for (const key in data) loaded.push({ id: key, ...data[key] });
      loaded.sort((a, b) => a.timestamp - b.timestamp);
      setQueue(loaded);

      if (!isInitialDataLoaded.current) {
          setTimeout(() => { isInitialDataLoaded.current = true; }, 1500); 
      }
    });

    const unsubLogs = onValue(logsRef, (snapshot) => {
      const data = snapshot.val();
      const loadedLogs = [];
      if (data) for (const key in data) loadedLogs.push({ id: key, ...data[key] });
      loadedLogs.sort((a, b) => b.timestamp - a.timestamp);
      setLogs(loadedLogs.slice(0, 100)); 
    });
    
    const unsubSettings = onValue(settingsRef, (snap) => {
      if (snap.exists()) setMaxLimit(snap.val());
    });

    return () => {
        off(queueRef);
        off(logsRef);
        off(settingsRef);
    };
  }, [userCompany]);

  const sistemLogEkle = (mesaj, logUid = null, logAdSoyad = null, targetComp = null) => {
      const companyToLog = targetComp || userCompany;
      if (!companyToLog) return;
      push(ref(database, `logs/${companyToLog}`), {
          mesaj: mesaj,
          timestamp: Date.now(),
          uid: logUid,
          adSoyad: logAdSoyad
      }).catch((error) => console.error("Log yazılamadı:", error));
  };

  useEffect(() => {
      if (!isAdmin || logs.length === 0 || !userCompany) return;

      const silinecekLoglar = logs.filter(log => log.timestamp < resetTimestamp);

      if (silinecekLoglar.length > 0 && !isCleaning.current) {
          isCleaning.current = true; 
          
          silinecekLoglar.forEach(log => {
              remove(ref(database, `logs/${userCompany}/${log.id}`)).catch(()=>{});
          });

          sistemLogEkle("🧹 Sistem: Yeni gün başladı, eski log kayıtları temizlendi.");

          setTimeout(() => { isCleaning.current = false; }, 5000);
      }
  }, [logs, isAdmin, resetTimestamp, userCompany]);

  const loglariIndir = () => {
      if (gecerliLoglar.length === 0) return alert("İndirilecek kayıt bulunamadı.");
      const sirketAdi = userCompany === 'turknet' ? 'TURKNET' : 'SITETELEKOM';
      let dosyaIcerigi = `${sirketAdi} MOLA UYGULAMASI - SİSTEM KAYITLARI\n`;
      dosyaIcerigi += "==================================================\n\n";

      gecerliLoglar.forEach(log => {
          const date = new Date(log.timestamp);
          const timeStr = `${date.getHours().toString().padStart(2,'0')}:${date.getMinutes().toString().padStart(2,'0')}`;
          const dateStr = `${date.getDate().toString().padStart(2,'0')}/${(date.getMonth()+1).toString().padStart(2,'0')}/${date.getFullYear()}`;
          dosyaIcerigi += `[${dateStr} - ${timeStr}] ${log.mesaj}\n`;
      });

      dosyaIcerigi += "\n════════  Coding by Recep Can UYGUN | 2026 ════════\n";

      const blob = new Blob([dosyaIcerigi], { type: 'text/plain;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${sirketAdi}_Mola_Kayitlari_${new Date().toLocaleDateString()}.txt`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  };

  const kisiDetaylariniIndir = () => {
      if (analyzedUsers.length === 0) return alert("İndirilecek kişi detayı bulunamadı.");
      const sirketAdi = userCompany === 'turknet' ? 'TURKNET' : 'SITETELEKOM';
      let dosyaIcerigi = `${sirketAdi} MOLA UYGULAMASI - KİŞİ DETAYLARI VE İHLAL RAPORU\n`;
      dosyaIcerigi += "========================================================\n\n";

      analyzedUsers.forEach(stat => {
          dosyaIcerigi += `KİŞİ: ${stat.name}\n`;
          dosyaIcerigi += `TOPLAM MOLA İSTEĞİ: ${stat.count}\n`;
          
          if (stat.warnings.length > 0) {
              dosyaIcerigi += `İHLALLER:\n`;
              stat.warnings.forEach(w => dosyaIcerigi += `  - ${w}\n`);
          } else {
              dosyaIcerigi += `DURUM: Kural ihlali bulunmuyor.\n`;
          }
          dosyaIcerigi += `--------------------------------------------------------\n\n`;
      });

      dosyaIcerigi += "════════  Coding by Recep Can UYGUN | 2026 ════════\n";

      const blob = new Blob([dosyaIcerigi], { type: 'text/plain;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${sirketAdi}_Kisi_Ihlal_Raporu_${new Date().toLocaleDateString()}.txt`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  };

  const handleLogin = () => {
      signInWithRedirect(auth, provider).catch((error) => console.error("Giriş Hatası:", error));
  };

  const saveProfile = () => {
      if (!customName || !customName.trim()) return alert("Lütfen isminizi yazın.");
      if (!userCompany && !selectedCompany) return alert("Lütfen firmanızı seçin.");

      const finalCompany = userCompany || selectedCompany;

      set(ref(database, `users/${user.uid}`), { 
          adSoyad: customName, 
          email: user.email,
          company: finalCompany 
      });
      setIsEditingProfile(false);
  };
  
  const handleTransferRequest = (targetCompany) => {
      if (userCompany === targetCompany) return;
      const targetName = targetCompany === 'turknet' ? 'TURKNET' : 'SİTETELEKOM';
      
      if (isAdmin) {
          if (window.confirm(`Yönetici yetkinizle anında ${targetName} çalışma alanına geçmek istiyor musunuz?`)) {
              const userInQueue = queue.find(q => q.uid === user.uid);
              if (userInQueue) {
                  remove(ref(database, `molaSirasi/${userCompany}/${userInQueue.id}`));
              }
              sistemLogEkle(`👑 Yönetici (${savedName}), çalışma alanını ${targetName} olarak değiştirerek aramızdan ayrıldı.`, user.uid, savedName);
              set(ref(database, `users/${user.uid}/company`), targetCompany);
              sistemLogEkle(`👑 Yönetici (${savedName}), ${targetName} ekibine geçiş yaptı.`, user.uid, savedName, targetCompany);
              setIsDropdownOpen(false);
          }
          return; 
      }

      if (window.confirm(`Çalışma alanınızı ${targetName} olarak değiştirmek istiyor musunuz? Bu işlem karşı şirket yöneticisinin onayına tabidir.`)) {
          push(ref(database, `transferRequests/${targetCompany}`), {
              uid: user.uid,
              adSoyad: savedName,
              from: userCompany,
              to: targetCompany,
              timestamp: Date.now()
          }).then(() => {
              setToastMessage("Geçiş talebiniz karşı şirket yöneticisine iletildi. Onay bekleniyor.");
              setIsDropdownOpen(false);
          }).catch((err) => {
              alert("⚠️ Hata: Firebase Veritabanı Kuralları bu işleme izin vermiyor!");
              console.error(err);
          });
      }
  };

  const handleApprove = async (req) => {
      try {
          await set(ref(database, `users/${req.uid}/company`), req.to);

          const targetName = req.to === 'turknet' ? 'TURKNET' : 'SİTETELEKOM';
          const fromName = req.from === 'turknet' ? 'TURKNET' : 'SİTETELEKOM';
          
          sistemLogEkle(`👑 ${targetName} Yöneticisi: ${req.adSoyad} adlı kullanıcının geçiş talebini ONAYLADI.`, req.uid, req.adSoyad, req.from);
          sistemLogEkle(`👋 Sistem: ${req.adSoyad} adlı kullanıcı ${fromName} ekibinden aramıza katıldı.`, req.uid, req.adSoyad, req.to);

          const queueSnap = await get(ref(database, `molaSirasi/${req.from}`));
          if (queueSnap.exists()) {
              const qData = queueSnap.val();
              for (const key in qData) {
                  if (qData[key].uid === req.uid) {
                      await remove(ref(database, `molaSirasi/${req.from}/${key}`));
                  }
              }
          }

          await remove(ref(database, `transferRequests/${req.to}/${req.id}`));
          await remove(ref(database, `transferRequests/${req.from}/${req.id}`));
          
          alert(`✅ ${req.adSoyad} adlı kullanıcının geçişi başarıyla onaylandı.`);
      } catch (error) {
          console.error("Onaylama sırasında hata:", error);
      }
  };

  const handleReject = async (req) => {
      try {
          const targetName = req.to === 'turknet' ? 'TURKNET' : 'SİTETELEKOM';
          sistemLogEkle(`👑 ${targetName} Yöneticisi: ${req.adSoyad} adlı kullanıcının geçiş talebini REDDETTİ.`, req.uid, req.adSoyad, req.from);
          
          await remove(ref(database, `transferRequests/${req.to}/${req.id}`));
          await remove(ref(database, `transferRequests/${req.from}/${req.id}`));
          
          alert(`❌ ${req.adSoyad} adlı kullanıcının talebi reddedildi.`);
      } catch (error) {
          console.error("Reddetme sırasında hata:", error);
      }
  };

  const sirayaKatil = () => {
    if (!userCompany) return alert("Lütfen profil kurulumunuzu tamamlayın.");
    if (queue.find(i => i.uid === user.uid)) return alert("Zaten sıradasınız!");

    const now = new Date();
    push(ref(database, `molaSirasi/${userCompany}`), {
      adSoyad: savedName, 
      zaman: `${now.getHours()}:${String(now.getMinutes()).padStart(2,'0')}`,
      timestamp: Date.now(),
      uid: user.uid,
      photo: user.photoURL
    });

    if (queue.length < maxLimit) {
        sistemLogEkle(`☕ ${savedName} moladakiler kısmına, mola sırasında boş yer olduğu için katıldı.`, user.uid, savedName);
    } else {
        sistemLogEkle(`⏳ ${savedName} sırada bekleyenler kısmına katıldı.`, user.uid, savedName);
    }
  };

  const siradanCik = (item) => {
    if (isAdmin || (user && item.uid === user.uid)) {
      if(isAdmin && item.uid !== user.uid) {
          if (!window.confirm("Bu kişiyi sıradan çıkarmak istediğinize emin misiniz?")) return;
          const yoneticiAdi = savedName ? savedName : "Yönetici";
          sistemLogEkle(`👑 Yönetici (${yoneticiAdi}): ${item.adSoyad} mola sırasından çıkarıldı.`, item.uid, item.adSoyad);
      } else {
          sistemLogEkle(`👋 ${item.adSoyad} kendi isteğiyle mola sırasından ayrıldı.`, item.uid, item.adSoyad);
      }

      const removedIndex = queue.findIndex(q => q.id === item.id);
      if (removedIndex > -1 && removedIndex < maxLimit && queue.length > maxLimit) {
          const promotedUser = queue[maxLimit]; 
          sistemLogEkle(`☕ ${promotedUser.adSoyad} moladakiler kısmına, sırası geldiği için otomatik katıldı.`, promotedUser.uid, promotedUser.adSoyad);
      }

      remove(ref(database, `molaSirasi/${userCompany}/${item.id}`));
    }
  };

  const handleLimitChange = (e) => {
    if(!userCompany) return;
    const val = e.target.value;
    if (val === "") {
        set(ref(database, `settings/${userCompany}/maxLimit`), "");
    } else {
        const newLimit = parseInt(val);
        set(ref(database, `settings/${userCompany}/maxLimit`), newLimit);
        const yoneticiAdi = savedName ? savedName : "Yönetici";
        sistemLogEkle(`⚙️ Yönetici (${yoneticiAdi}): Mola limiti ${newLimit} olarak güncellendi.`);
        
        if (newLimit > maxLimit && queue.length > maxLimit) {
            const promotedUsers = queue.slice(maxLimit, newLimit);
            promotedUsers.forEach(u => {
                sistemLogEkle(`☕ ${u.adSoyad} moladakiler kısmına, limit artırıldığı için otomatik katıldı.`, u.uid, u.adSoyad);
            });
        }
    }
  };

  const activeBreaks = queue.slice(0, maxLimit); 
  const waitingQueue = queue.slice(maxLimit);    

  useEffect(() => {
    const currentActiveBreaks = queue.slice(0, maxLimit);

    if (!isInitialDataLoaded.current) {
        prevActiveBreaks.current = currentActiveBreaks;
        return;
    }

    const yeniMolayaGecenler = currentActiveBreaks.filter(aktif => 
        !prevActiveBreaks.current.find(eski => eski.uid === aktif.uid)
    );

    if (yeniMolayaGecenler.length > 0) {
        if (user && yeniMolayaGecenler.some(kisi => kisi.uid === user.uid)) {
            
            const zil = new Audio(process.env.PUBLIC_URL + "/zil.mp3");
            zil.play().catch(err => console.log("Otomatik ses engellendi:", err));

            setToastMessage("Artık molaya çıkabilirsin! İyi dinlenmeler.");
            setTimeout(() => setToastMessage(null), 12000); 

            if ("Notification" in window && Notification.permission === "granted") {
                const title = "☕ Mola Sırası Sende!";
                const options = { 
                    body: "Artık molaya çıkabilirsin! İyi dinlenmeler.", 
                    icon: "/logo.png",
                    requireInteraction: true 
                };

                try {
                    if ('serviceWorker' in navigator) {
                        navigator.serviceWorker.getRegistrations().then(function(registrations) {
                            let isShown = false;
                            for (let registration of registrations) {
                                if (registration.active) {
                                    registration.showNotification(title, options);
                                    isShown = true;
                                    break;
                                }
                            }
                            if (!isShown) new Notification(title, options);
                        }).catch(() => new Notification(title, options));
                    } else {
                        new Notification(title, options);
                    }
                } catch (error) {
                    new Notification(title, options);
                }
            }
        }
    }

    prevActiveBreaks.current = currentActiveBreaks;
  }, [queue, maxLimit, user]);

  if (isAuthChecking) return <div className="app-container"><p>Yükleniyor...</p></div>;

  if (!user) {
      return (
          <div className={`app-container ${darkMode ? '' : 'light-mode'}`}>
              <div className="background-blob blob-1"></div>
              <div className="background-blob blob-2"></div>
              <div className="auth-screen">
                  <div className="auth-card">
                      <img src={process.env.PUBLIC_URL + '/logo2.png'} alt="Logo" className="auth-logo"/>
                      <h2 className="auth-title">Mola Yönetim Sistemi</h2>
                      <p className="auth-subtitle">Devam etmek için Google hesabınızla giriş yapın.</p>
                      <button className="btn-large-login" onClick={handleLogin}>
                          <img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="G" style={{width: '20px'}}/>
                          Google ile Giriş Yap
                      </button>
                  </div>
              </div>
              <a href="https://moladayiz.biz/modem" target="_blank" rel="noopener noreferrer" className="modem-btn" title="Modem Paneli">🛜</a>
              <button className="theme-toggle" onClick={() => setDarkMode(!darkMode)}>{darkMode ? "☀️" : "🌙"}</button>
          </div>
      );
  }

  if (user && (!savedName || !userCompany || isEditingProfile)) {
      return (
          <div className={`app-container ${darkMode ? '' : 'light-mode'}`}>
              <div className="background-blob blob-1"></div>
              <div className="background-blob blob-2"></div>
              <div className="auth-screen">
                  <div className="auth-card">
                      <h2 className="auth-title">{userCompany ? "Profilini Düzenle" : "Profilini Tamamla"}</h2>
                      <p className="auth-subtitle">{userCompany ? "İsmini buradan güncelleyebilirsin." : "Sistemi kullanabilmek için isim ve firma seçmelisin."}</p>
                      
                      <input 
                          type="text" 
                          className="name-input" 
                          placeholder="İsim Soyisim" 
                          value={customName} 
                          onChange={(e) => setCustomName(e.target.value)} 
                          maxLength={25} 
                      />

                      {!userCompany && (
                          <div className="company-selector">
                              <button 
                                  className={`company-btn ${selectedCompany === 'turknet' ? 'active' : ''}`}
                                  onClick={() => setSelectedCompany('turknet')}
                              >
                                  <span className="company-icon">🏢</span> TurkNet
                              </button>
                              <button 
                                  className={`company-btn ${selectedCompany === 'sitetelekom' ? 'active' : ''}`}
                                  onClick={() => setSelectedCompany('sitetelekom')}
                              >
                                  <span className="company-icon">🌐</span> SiteTelekom
                              </button>
                          </div>
                      )}

                      <button className="btn-join" onClick={saveProfile}>
                          {userCompany ? "BİLGİLERİMİ GÜNCELLE" : "KAYDET VE BAŞLA"}
                      </button>
                  </div>
              </div>
              <a href="https://moladayiz.biz/modem" target="_blank" rel="noopener noreferrer" className="modem-btn" title="Modem Paneli">🛜</a>
              <button className="theme-toggle" onClick={() => setDarkMode(!darkMode)}>{darkMode ? "☀️" : "🌙"}</button>
          </div>
      );
  }

  return (
    <div className={`app-container ${darkMode ? '' : 'light-mode'}`}>
      <div className="background-blob blob-1"></div>
      <div className="background-blob blob-2"></div>

      {userCompany && (
          <div className="company-dropdown-container">
              <button 
                  className="page-top-left-badge custom-dropdown-btn"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                  {userCompany === 'turknet' ? '🏢 TURKNET' : '🌐 SİTETELEKOM'}
                  <span className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}>▼</span>
              </button>

              {isDropdownOpen && (
                  <>
                      <div className="dropdown-overlay" onClick={() => setIsDropdownOpen(false)}></div>
                      
                      <div className="custom-dropdown-menu">
                          <div 
                              className={`dropdown-item ${userCompany === 'turknet' ? 'active' : ''}`}
                              onClick={() => handleTransferRequest('turknet')}
                          >
                              🏢 TURKNET
                          </div>
                          <div 
                              className={`dropdown-item ${userCompany === 'sitetelekom' ? 'active' : ''}`}
                              onClick={() => handleTransferRequest('sitetelekom')}
                          >
                              🌐 SİTETELEKOM
                          </div>
                      </div>
                  </>
              )}
          </div>
      )}

      {toastMessage && (
          <div className="custom-toast">
              <span className="toast-icon">🔔</span>
              <div className="toast-content">
                  <strong>Sistem Bildirimi</strong>
                  <p>{toastMessage}</p>
              </div>
              <button className="toast-close" onClick={() => setToastMessage(null)}>✖</button>
          </div>
      )}

      <div className="card">
        <div className="header-top">
            <img src={process.env.PUBLIC_URL + '/logo2.png'} alt="Logo" className="logo-img"/>
            <div className="header-right">
                <div className="user-info">
                    <div className="avatar-wrapper">
                        <img src={user.photoURL} alt="p" className="user-avatar"/>
                        {isAdmin && <span className="admin-crown">👑</span>}
                    </div>
                    <button className="btn-logout" onClick={() => signOut(auth)}>Çıkış</button>
                </div>
            </div>
        </div>

        {isAdmin && (
            <div className="tab-menu" style={{ flexWrap: 'wrap' }}>
                <button 
                    className={`tab-btn ${activeTab === 'home' ? 'active' : ''}`} 
                    onClick={() => setActiveTab('home')}
                >
                    🏠 Ana Ekran
                </button>
                <button 
                    className={`tab-btn ${activeTab === 'logs' || activeTab === 'users' ? 'active' : ''}`} 
                    onClick={() => setActiveTab('logs')}
                >
                    📜 Log Kayıtları
                </button>
                <button 
                    className={`tab-btn ${activeTab === 'requests' ? 'active' : ''}`} 
                    onClick={() => setActiveTab('requests')}
                >
                    🔔 Talepler {pendingRequests.length > 0 && `(${pendingRequests.length})`}
                </button>
            </div>
        )}

        {activeTab === 'home' && (
            <>
                <div className="info-section">
                    <div className="info-box">Sıra bilgisi anlık güncellenir.</div>
                    <div className="info-box">Aynı anda <strong>{maxLimit}</strong> kişi molada olabilir.</div>
                </div>

                <div className="join-area">
                    <div className="welcome-container">
                        <div className="welcome-text">
                            <span>Merhaba,</span><strong>{savedName}</strong><span className="wave-emoji">👋</span>
                        </div>
                        <button className="btn-edit" onClick={() => setIsEditingProfile(true)}>✏️</button>
                    </div>

                    {!queue.find(i => i.uid === user.uid) && (
                        <button className="btn-join" onClick={sirayaKatil}>SIRAYA GİR</button>
                    )}
                </div>

                <div className="section-panel active-panel">
                    <h3 className="section-title">☕ MOLADAKİLER <span className="count-badge">{activeBreaks.length}/{maxLimit}</span></h3>
                    <div className="list-content">
                        {activeBreaks.length === 0 ? <p className="empty-message">Şu an molada kimse yok.</p> : 
                            activeBreaks.map((item, index) => (
                            <div key={item.id} className={`list-item active-item ${user && item.uid === user.uid ? 'my-item' : ''}`}>
                                <span className="col-rank">#{index + 1}</span>
                                <span className="col-time">{item.zaman}</span>
                                <div className="col-name">
                                    {item.photo && <img src={item.photo} alt="t" className="mini-avatar"/>}
                                    <strong>{item.adSoyad}</strong>
                                </div>
                                <div className="col-action">
                                    {(isAdmin || (user && item.uid === user.uid)) && <button className="btn-delete" onClick={() => siradanCik(item)}>X</button>}
                                </div>
                            </div>
                            ))
                        }
                    </div>
                </div>

                <div className="section-panel waiting-panel">
                    <h3 className="section-title">⏳ SIRADA BEKLEYENLER <span className="count-badge waiting-badge">{waitingQueue.length}</span></h3>
                    <div className="list-content">
                        {waitingQueue.length === 0 ? <p className="empty-message">Sırada bekleyen yok.</p> : 
                            waitingQueue.map((item, index) => (
                            <div key={item.id} className={`list-item waiting-item ${user && item.uid === user.uid ? 'my-item' : ''}`}>
                                <span className="col-rank">{index + 1}.</span>
                                <span className="col-time">{item.zaman}</span>
                                <div className="col-name">
                                    {item.photo && <img src={item.photo} alt="t" className="mini-avatar grayscale"/>}
                                    {item.adSoyad}
                                </div>
                                <div className="col-action">
                                    {(isAdmin || (user && item.uid === user.uid)) && <button className="btn-delete" onClick={() => siradanCik(item)}>X</button>}
                                </div>
                            </div>
                            ))
                        }
                    </div>
                </div>

                {isAdmin && (
                    <div className="admin-panel">
                        <label>LİMİT:</label>
                        <input type="number" value={maxLimit} onChange={handleLimitChange} />
                    </div>
                )}
            </>
        )}

        {activeTab === 'logs' && (
            <div className="section-panel logs-panel">
                
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                    <button className="btn-download" onClick={() => setActiveTab('users')} style={{ background: 'linear-gradient(135deg, #6b21a8, #4c1d95)' }}>
                        👥 Kişi Detayları ve İhlaller
                    </button>
                </div>

                <h3 className="section-title">📜 {userCompany === 'turknet' ? 'TURKNET' : 'SITETELEKOM'} KAYITLARI</h3>
                <p className="logs-subtitle">Kayıtlar, her sabah 08:00'de temizlenir.</p>
                <div className="list-content logs-content">
                    {gecerliLoglar.length === 0 ? <p className="empty-message">Henüz bir sistem kaydı bulunmuyor.</p> : 
                        gecerliLoglar.map(log => {
                            const date = new Date(log.timestamp);
                            const timeStr = `${date.getHours().toString().padStart(2,'0')}:${date.getMinutes().toString().padStart(2,'0')}`;
                            const dateStr = `${date.getDate().toString().padStart(2,'0')}/${(date.getMonth()+1).toString().padStart(2,'0')}`;
                            return (
                                <div key={log.id} className="log-item">
                                    <span className="log-date">{dateStr} - {timeStr}</span>
                                    <span className="log-message">{log.mesaj}</span>
                                </div>
                            );
                        })
                    }
                </div>
                
                <div className="download-container" style={{ marginTop: '20px' }}>
                    <button className="btn-download" onClick={loglariIndir}>
                        📥 Kayıtları Bilgisayara İndir
                    </button>
                </div>
            </div>
        )}

        {activeTab === 'users' && (
            <div className="section-panel logs-panel">

                <h3 className="section-title">👥 KİŞİ DETAYLARI</h3>
                <p className="logs-subtitle">Bugün sıraya giren kişilerin istatistikleri (Her sabah 08:00'de sıfırlanır).</p>
                
                <div className="list-content logs-content">
                    {analyzedUsers.length === 0 ? <p className="empty-message">Bugün henüz kimse mola istemedi.</p> : 
                        analyzedUsers.map((stat, index) => (
                            <div key={index} className="user-stat-card">
                                <div className="stat-header">
                                    <span>{stat.name}</span>
                                    <span className="stat-count">Toplam İstek: {stat.count}</span>
                                </div>
                                <div className="stat-warnings">
                                    {stat.warnings.length > 0 ? (
                                        stat.warnings.map((warn, wIndex) => (
                                            <span key={wIndex} className="warning-item">{warn}</span>
                                        ))
                                    ) : (
                                        <span className="ok-message">✅ Kural ihlali bulunmuyor.</span>
                                    )}
                                </div>
                            </div>
                        ))
                    }
                </div>

                <div className="download-container" style={{ marginTop: '20px' }}>
                    <button className="btn-download" onClick={kisiDetaylariniIndir} style={{ background: 'linear-gradient(135deg, #6b21a8, #4c1d95)' }}>
                        📥 Kişi İhlal Raporunu İndir
                    </button>
                </div>

            </div>
        )}

        {activeTab === 'requests' && isAdmin && (
            <div className="section-panel logs-panel">
                <h3 className="section-title">🔔 ONAY BEKLEYEN GEÇİŞ TALEPLERİ</h3>
                <p className="logs-subtitle">Firmanıza katılmak isteyen kullanıcıların taleplerini buradan yönetebilirsiniz.</p>
                
                <div className="list-content logs-content">
                    {pendingRequests.length === 0 ? <p className="empty-message">Şu an onay bekleyen talep bulunmuyor.</p> : 
                        pendingRequests.map((req) => (
                            <div key={req.id} className="user-stat-card" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div className="stat-header">
                                    <span>{req.adSoyad}</span>
                                    <span className="stat-count" style={{ background: '#7c3aed' }}>
                                        {req.from === 'turknet' ? '🏢 TURKNET\'ten Geliyor' : '🌐 SİTETELEKOM\'dan Geliyor'}
                                    </span>
                                </div>
                                <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                                    Kullanıcıyı onayladığınız an kendi şirketinin mola sırasından çıkarılacak ve sizin ekibinize eklenecektir.
                                </div>
                                <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                                    <button 
                                        onClick={() => handleApprove(req)} 
                                        style={{ flex: 1, padding: '10px', background: 'linear-gradient(135deg, #28a745, #218838)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 10px rgba(40, 167, 69, 0.3)' }}
                                    >
                                        ✅ ONAYLA
                                    </button>
                                    <button 
                                        onClick={() => handleReject(req)} 
                                        style={{ flex: 1, padding: '10px', background: 'linear-gradient(135deg, #dc3545, #c82333)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 10px rgba(220, 53, 69, 0.3)' }}
                                    >
                                        ❌ REDDET
                                    </button>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        )}

        <div className="footer">Recep Can UYGUN @ TurkNet | Mola 2026 v1.0</div>
        
        <a href="https://moladayiz.biz/modem" target="_blank" rel="noopener noreferrer" className="modem-btn" title="Modem Paneli">
            🛜
        </a>

        <button className="theme-toggle" onClick={() => setDarkMode(!darkMode)}>{darkMode ? "☀️" : "🌙"}</button>
      </div>
    </div>
  );
}

export default App;